import { render, staticRenderFns } from "./CustomerLinksCard.vue?vue&type=template&id=1e006052&scoped=true"
import script from "./CustomerLinksCard.vue?vue&type=script&lang=js"
export * from "./CustomerLinksCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerLinksCard.vue?vue&type=style&index=0&id=1e006052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e006052",
  null
  
)

export default component.exports